import React, { Component } from 'react';
import Aux from '../../../components/Hoc/Aux';
import Reasons from '../../../components/Reasons/ReasonsSmallBizMarket';
import Testimonials from '../../../components/Testimonials/Testimonials';

class SmallBusinessMarket extends Component {
  componentDidMount () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'visitorType': 'Group',
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - Hudson Valley Large Group Lead',
      'eventValue': undefined
    });
  }

  render () {
    return (
      <Aux>
        <Reasons tab={this.props.tab} />
        <Testimonials heading='“We switched to CDPHP, and we&rsquo;ve been happy ever&nbsp;since.”' slides='smallbiz' smallBiz='true' />
      </Aux>
    );
  }
}

SmallBusinessMarket.propTypes = { // validate props expected
};

export default SmallBusinessMarket;
